import { defineMessages } from 'react-intl'

export default defineMessages({
  claimsClaimTypeCall: {
    id: 'app.claims.claimType.call',
    defaultMessage: 'Make a call',
  },
  claimsClaimTypeForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
  claimsClaimTypeCallSubtitle: {
    id: 'app.claims.claimType.call.subtitle',
    defaultMessage: 'Hate to type?',
  },
  claimsClaimTypeFormSubtitle: {
    id: 'app.claims.claimType.form.subtitle',
    defaultMessage: 'Type away',
  },
})
